/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * The Emails Listing Context
 * @export
 */
const EmailsListingContext = createContext({
    isLoading: true,
    isReady: false,
    isAuthNeeded: false,
    error: null,
    signInLink: null,
    restartAuthProcess: null,
    mailboxLink: null,
});

EmailsListingContext.Provider.propTypes = {
    value: PropTypes.shape({
        isLoading: PropTypes.bool,
        isReady: PropTypes.bool,
        error: PropTypes.symbol,
        isAuthNeeded: PropTypes.bool, // Does the user need to login to 3rd party
        signInLink: PropTypes.element,
        restartAuthProcess: PropTypes.func,
        mailboxLink: PropTypes.string,
        emails: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                from: PropTypes.string,
                title: PropTypes.string,
                isRead: PropTypes.bool,
                link: PropTypes.string,
                subtitle: PropTypes.string,
            })
        ),
    }),
};

export const EmailsListingContextErrorType = Object.freeze({
    AUTH_ERROR: Symbol('AUTH_ERROR'),
    SCOPE_ERROR: Symbol('SCOPE_ERROR'),
    POPUP_ERROR: Symbol('POPUP_ERROR'),
    ERROR: Symbol('ERROR'),
});

export default EmailsListingContext;
